import type { AssignmentsType } from 'core/types';

export default (current: AssignmentsType, previous: AssignmentsType) =>
  current?.due !== previous?.due ||
  current?.responsible !== previous?.responsible ||
  current?.status !== previous?.status ||
  current?.author !== previous?.author ||
  current?.comment !== previous?.comment;
